/**
 * This file provides type-safe style interpolation for common themed elements.
 */ import { MaterialColors as Colors } from "../index";
export var BLACK = "rgb(0, 0, 0)";
export var WHITE = Colors.KAGGLE_WHITE;
export var MediaType;
(function(MediaType) {
    MediaType["ALL"] = "all";
    MediaType["PRINT"] = "print";
    MediaType["ONLY_PRINT"] = "only print";
    MediaType["NOT_PRINT"] = "not print";
    MediaType["SCREEN"] = "screen";
    MediaType["ONLY_SCREEN"] = "only screen";
    MediaType["NOT_SCREEN"] = "not screen";
    MediaType["SPEECH"] = "speech";
    MediaType["ONLY_SPEECH"] = "only speech";
    MediaType["NOT_SPEECH"] = "not speech";
})(MediaType || (MediaType = {}));
export var BreakpointDown;
(function(BreakpointDown) {
    BreakpointDown[// Where Jupyters notebook cell responsive breakpoint is.
    /** iPhone, Samsung Galaxy */ "XXXXS"] = "(max-width: 375px)";
    BreakpointDown[/** Pixel */ "XXXS"] = "(max-width: 480px)";
    BreakpointDown["XXS"] = "(max-width: 540px)";
    BreakpointDown["XS"] = "(max-width: 575px)";
    BreakpointDown["S"] = "(max-width: 671px)";
    BreakpointDown["M"] = "(max-width: 840px)";
    BreakpointDown["L"] = "(max-width: 991px)";
    BreakpointDown["XL"] = "(max-width: 1199px)";
    BreakpointDown[// KM aliases
    "PHONE"] = "(max-width: 480px)";
    BreakpointDown["TABLET"] = "(max-width: 840px)";
    BreakpointDown["DESKTOP"] = "(max-width: 1199px)";
})(BreakpointDown || (BreakpointDown = {}));
export var BreakpointUp;
(function(BreakpointUp) {
    BreakpointUp[// Where Jupyters notebook cell responsive breakpoint is.
    "XXXXS"] = "(min-width: 376px)";
    BreakpointUp["XXXS"] = "(min-width: 481px)";
    BreakpointUp["XXS"] = "(min-width: 541px)";
    BreakpointUp["XS"] = "(min-width: 576px)";
    BreakpointUp["S"] = "(min-width: 672px)";
    BreakpointUp["M"] = "(min-width: 841px)";
    BreakpointUp["L"] = "(min-width: 992px)";
    BreakpointUp["XL"] = "(min-width: 1200px)";
    BreakpointUp[// KM aliases
    "PHONE"] = "(min-width: 481px)";
    BreakpointUp["TABLET"] = "(min-width: 841px)";
    BreakpointUp["DESKTOP"] = "(min-width: 1200px)";
})(BreakpointUp || (BreakpointUp = {}));
export var MaterialBreakpointDown;
(function(MaterialBreakpointDown) {
    MaterialBreakpointDown[// Phone: < 480
    "XS1"] = "(max-width: 359px)";
    MaterialBreakpointDown["XS2"] = "(max-width: 399px)";
    MaterialBreakpointDown["XS3"] = "(max-width: 479px)";
    MaterialBreakpointDown[// Tablet (portrait): 480 - 839
    "SM1"] = "(max-width: 599px)";
    MaterialBreakpointDown["SM2"] = "(max-width: 719px)";
    MaterialBreakpointDown["SM3"] = "(max-width: 839px)";
    MaterialBreakpointDown[// TBD, possibly "Large Tablet": 840 - 1023, see above re: ongoing revisions.
    "MD1"] = "(max-width: 959px)";
    MaterialBreakpointDown["MD2"] = "(max-width: 1023px)";
    MaterialBreakpointDown[// TBD, possibly "Desktop": 1024-1279, see above re: ongoing revisions.
    "LG1"] = "(max-width: 1279px)";
    MaterialBreakpointDown[// Desktop: 1280+
    "LG2"] = "(max-width: 1439px)";
    MaterialBreakpointDown["LG3"] = "(max-width: 1599px)";
    MaterialBreakpointDown["XL1"] = "(max-width: 1919px)";
    MaterialBreakpointDown["PHONE"] = "(max-width: 479px)";
    MaterialBreakpointDown["TABLET"] = "(max-width: 839px)";
    MaterialBreakpointDown["DESKTOP"] = "(max-width: 1279px)";
    MaterialBreakpointDown[// Mobile orientation media queries. Note: orientation does *not* always mean
    // device orientation, as it relies on viewport width > height checks.
    "PHONE_PORTRAIT"] = "(max-width: 479px) and (orientation: portrait)";
    MaterialBreakpointDown["PHONE_LANDSCAPE"] = "(max-height: 479px) and (orientation: landscape)";
})(MaterialBreakpointDown || (MaterialBreakpointDown = {}));
export var MaterialBreakpointUp;
(function(MaterialBreakpointUp) {
    MaterialBreakpointUp[// Phone: < 480
    "XS1"] = "(min-width: 360px)";
    MaterialBreakpointUp["XS2"] = "(min-width: 400px)";
    MaterialBreakpointUp[// Tablet (portrait): 480 - 839
    "XS3"] = "(min-width: 480px)";
    MaterialBreakpointUp["SM1"] = "(min-width: 600px)";
    MaterialBreakpointUp["SM2"] = "(min-width: 720px)";
    MaterialBreakpointUp[// TBD, possibly "Large Tablet": 840 - 1023, see above re: ongoing revisions.
    "SM3"] = "(min-width: 840px)";
    MaterialBreakpointUp["MD1"] = "(min-width: 960px)";
    MaterialBreakpointUp[// TBD, possibly "Desktop": 1024-1279, see above re: ongoing revisions.
    "MD2"] = "(min-width: 1024px)";
    MaterialBreakpointUp[// Desktop: 1280+
    "LG1"] = "(min-width: 1280px)";
    MaterialBreakpointUp["LG2"] = "(min-width: 1440px)";
    MaterialBreakpointUp["LG3"] = "(min-width: 1600px)";
    MaterialBreakpointUp["XL1"] = "(min-width: 1920px)";
    MaterialBreakpointUp[// TODO(b/261081965): Phone and tablet seem like their aliased breakpoints
    // are incorrect for MaterialBreakpointUp. :|
    "PHONE"] = "(min-width: 480px)";
    MaterialBreakpointUp["TABLET"] = "(min-width: 840px)";
    MaterialBreakpointUp["DESKTOP"] = "(min-width: 1280px)";
})(MaterialBreakpointUp || (MaterialBreakpointUp = {}));
export var darkPalette = {
    accent: Colors.GREY_200,
    lightLines: Colors.GREY_800,
    darkLines: Colors.GREY_800,
    sideBars: Colors.GREY_900,
    windowBackground: Colors.GREY_900,
    codeMirrorBackground: Colors.GREY_850,
    cellBackground: Colors.GREY_850,
    menuBackground: Colors.GREY_850,
    menuHoverBackground: Colors.GREY_800,
    text: {
        100: Colors.GREY_200,
        70: Colors.GREY_500,
        50: Colors.GREY_600
    },
    lineNumbers: Colors.GREY_600
};
export var syntax = {
    dark: {
        green: "#B9DF83",
        white: "#D3E4E4",
        black: "#526B77",
        magenta: "#C18EE4",
        cyan: "#7FCAE9",
        red: "#F3516C",
        yellow: "#FFCB6A",
        orange: "#EE886A",
        blue: "#7FA7FA"
    }
};
/** Converts a style value pair to CSS format. If the value is null it strips the style. */ var interpolateStyle = function(styleName, styleValue) {
    return styleName === null || styleValue === null ? "" : "".concat(styleName, ": ").concat(styleValue);
};
/** Extracts the themes style from a map. */ var getThemeStyle = function(styleMap) {
    return function(props) {
        return styleMap[props.themeName];
    };
};
/** Creates factories that switch styles based on theme name (light / dark ). */ export var themeNameStyle = function(styleName) {
    return function(valueMap) {
        return function(props, omitName) {
            var mapResult = typeof valueMap === "function" ? valueMap(props) : valueMap;
            var styleValue = getThemeStyle(mapResult)(props.theme.session);
            if (omitName === true) {
                return styleValue;
            }
            return interpolateStyle(styleName, styleValue);
        };
    };
};
/** General function to interpolate background style by theme name. */ export var backgroundTheme = themeNameStyle("background");
// TODO(b/206040004): Remove the lightColor params, and instead use a light
// palette, similar to the darkPalette.
/** Interpolates a code `background: <value>` prop into a styled-component, null values omit style for that theme. */ export var cellBackground = function() {
    var lightColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return backgroundTheme({
        dark: darkPalette.cellBackground,
        light: lightColor
    });
};
/** Interpolates a code mirror cell `background: <value>` prop into a styled-component, null values omit style for that theme. */ export var codeMirrorBackground = function() {
    var lightColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return backgroundTheme({
        dark: darkPalette.codeMirrorBackground,
        light: lightColor
    });
};
/** Interpolates a window `background: <value>` prop into a styled-component, null values omit style for that theme. */ export var windowBackground = function() {
    var lightColor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return backgroundTheme({
        dark: darkPalette.windowBackground,
        light: lightColor
    });
};
/** Interpolates a sidebar `background: <value>` prop into a styled-component, null values omit style for that theme. */ export var sidebarBackground = function() {
    return backgroundTheme({
        dark: darkPalette.sideBars,
        light: WHITE
    });
};
/** Interpolates a menu `background: <value>` prop into a styled-component, null values omit style for that theme. */ export var menuBackground = function() {
    return backgroundTheme({
        dark: darkPalette.menuBackground,
        light: Colors.KAGGLE_WHITE
    });
};
/** Interpolates a menu button `background: <value>` prop into a styled-component, null values omit style for that theme. */ export var menuButtonBackground = function() {
    return backgroundTheme({
        dark: darkPalette.menuBackground,
        light: "#f0f0f0"
    });
};
/** Interpolates a hovered menu button `background: <value>` prop into a styled-component, null values omit style for that theme. */ export var menuButtonHoverBackground = function() {
    return backgroundTheme({
        dark: darkPalette.menuHoverBackground,
        light: "#f0f0f0"
    });
};
/** Kaggle Material background color. */ export var materialBackground = function() {
    return backgroundTheme({
        dark: Colors.GREY_800,
        light: Colors.KAGGLE_WHITE
    });
};
/** Kaggle Material background color for a hovered interactable element. */ export var materialHoverBackground = function() {
    return backgroundTheme({
        dark: Colors.GREY_700,
        light: Colors.GREY_100
    });
};
/** Kaggle Material background color for alternate elements. */ export var materialSecondaryBackground = function() {
    return backgroundTheme({
        dark: Colors.GREY_900,
        light: Colors.GREY_50
    });
};
var getAccentTypeBackgroundColor = function(type, color) {
    return type === "error" ? color.legacy.status.errorBackground : color.legacy.status.validBackground;
};
/** Interpolates a brand button background color. Handles disabled property. */ export var brandButtonBackground = function() {
    return backgroundTheme(function(props) {
        return {
            light: props.disabled ? props.theme.legacyColors.brand.grey[800] : props.theme.legacyColors.brand.blue[800],
            dark: props.disabled ? props.theme.legacyColors.brand.grey[500] : props.theme.km.color.kaggle.blue
        };
    });
};
/** Interpolates a brand button hover background color. Handles disabled property. */ export var brandButtonHoverBackground = function() {
    return backgroundTheme(function(props) {
        return {
            light: props.disabled ? props.theme.legacyColors.brand.grey[800] : props.theme.legacyColors.brand.blue[900],
            dark: props.disabled ? props.theme.legacyColors.brand.grey[500] : props.theme.legacyColors.brand.blue[600]
        };
    });
};
/** Interpolates a accent button background color. Handles disabled property. */ export var accentButtonBackground = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "valid";
    return backgroundTheme(function(props) {
        return {
            light: props.disabled ? props.theme.legacyColors.brand.grey[800] : getAccentTypeBackgroundColor(type, props.theme.km.color),
            dark: props.disabled ? props.theme.legacyColors.brand.grey[500] : getAccentTypeBackgroundColor(type, props.theme.km.color)
        };
    });
};
/** Interpolates a accent button hover background color. Handles disabled property. */ export var accentButtonHoverBackground = function() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "valid";
    return backgroundTheme(function(props) {
        return {
            light: props.disabled ? props.theme.legacyColors.brand.grey[800] : getAccentTypeBackgroundColor(type, props.theme.km.color),
            dark: props.disabled ? props.theme.legacyColors.brand.grey[500] : getAccentTypeBackgroundColor(type, props.theme.km.color)
        };
    });
};
/** Interpolates the terminal background color into a styled-component. */ export var terminalBackground = function() {
    return backgroundTheme({
        dark: darkPalette.sideBars,
        light: darkPalette.sideBars
    });
};
/** Interpolates the modal background color into a styled-component. */ export var modalBackground = function() {
    return backgroundTheme({
        dark: darkPalette.sideBars,
        light: WHITE
    });
};
/** Interpolates a material box shadow into a styled-component. */ export var shadow = function() {
    return "\n  box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12);\n";
};
var formatBorderStyle = function(color) {
    return "1px solid ".concat(color);
};
/**
 * Interpolates a `border[-variant]: 1px solid <value>` prop into a styled-component.
 * Used in header and as a primary border style.
 */ export var primaryBorder = function() {
    var styleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "border";
    return themeNameStyle(styleName)(function(props) {
        return {
            light: formatBorderStyle(props.theme.legacyColors.border),
            dark: formatBorderStyle(darkPalette.darkLines)
        };
    });
};
/**
 * Interpolates a `border[-variant]: 1px solid <value>` prop into a styled-component.
 * Used in sidebar and as a secondary border style.
 */ export var secondaryBorder = function() {
    var styleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "border";
    return themeNameStyle(styleName)(function(props) {
        return {
            light: formatBorderStyle(props.theme.legacyColors.border),
            dark: formatBorderStyle(darkPalette.lightLines)
        };
    });
};
/** Interpolates an brand button border color. Handles disabled property. */ export var brandButtonBorder = function() {
    var styleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "border";
    return themeNameStyle(styleName)(function(props) {
        return {
            light: formatBorderStyle(props.disabled ? props.theme.legacyColors.brand.grey[900] : props.theme.legacyColors.brand.blue[900]),
            dark: formatBorderStyle(props.disabled ? props.theme.legacyColors.brand.grey[600] : props.theme.legacyColors.brand.blue[600])
        };
    });
};
/** Interpolates an accent button border color. Handles disabled property. */ export var accentButtonBorder = function() {
    var styleName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "border", type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "valid";
    return themeNameStyle(styleName)(function(props) {
        return {
            light: formatBorderStyle(props.disabled ? props.theme.legacyColors.brand.grey[900] : getAccentTypeBackgroundColor(type, props.theme.km.color)),
            dark: formatBorderStyle(props.disabled ? props.theme.legacyColors.brand.grey[600] : getAccentTypeBackgroundColor(type, props.theme.km.color))
        };
    });
};
/** Interpolates a `color: <value>` prop into a styled-component, null values omit style for that theme type. */ export var colorStyle = themeNameStyle("color");
export var getReadableColorValue = function(themeName) {
    var level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
    var values = {
        light: level === 50 ? "rgba(0,0,0,0.5)" : level === 70 ? "rgba(0, 0, 0, 0.7)" : BLACK,
        dark: darkPalette.text[level]
    };
    return values[themeName];
};
/** Interpolates a readable color with varying degrees of darkness. 100 (default) is full black / white. */ export var readableColor = function() {
    var level = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    return colorStyle({
        light: level === 50 ? "rgba(0,0,0,0.5)" : level === 70 ? "rgba(0, 0, 0, 0.7)" : BLACK,
        dark: darkPalette.text[level]
    });
};
/** Interpolates color style for button / theme. */ export var buttonColor = function() {
    return colorStyle({
        light: WHITE,
        dark: darkPalette.cellBackground
    });
};
/** Interpolates foreground color style for an input. */ export var inputColor = function() {
    return colorStyle({
        light: BLACK,
        dark: darkPalette.text[100]
    });
};
/** Interpolates placeholder `color: <color>;` for an input. Does not control the placeholder tag. */ export var inputPlaceholderColor = function() {
    return colorStyle({
        light: "rgba(0, 0, 0, 0.5)",
        dark: "rgba(255, 255, 255, 0.5)"
    });
};
/** Interpolates input background color. */ export var inputBackground = function() {
    return backgroundTheme({
        dark: darkPalette.windowBackground,
        light: WHITE
    });
};
/** Checks if a value is falsy, if it is it replaces with the passed string. */ var replaceFalsy = function(value, replacement) {
    return value === undefined || value === null || value === false ? replacement : value;
};
/**
 * Creates a tagged template literal that will only be included if the condition is met.
 *
 * @remarks
 * The following example would add a `background: white;` style only if the theme is dark.
 * ```tsx
 * const Foo = styled`
 *   ${styledConditional(props => props.theme.name === "dark")`
 *     background: white;
 *   `}
 * `;
 * ```
 *
 * It is recommended to create smaller functions in this file to break down variations like the above.
 */ export var styledConditional = function(condition) {
    /** The tagged template literal. */ var conditionalTemplateLiteral = function(strings) {
        for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            interpolations[_key - 1] = arguments[_key];
        }
        /** The styled interpolation that will be injected with the embedded literals props. */ var styledInterpolation = function(props) {
            var style = "";
            // If its not of the correct source type, don't return the style.
            if (!condition(props)) {
                return style;
            }
            var interpolate = function(interpolation) {
                // If the interpolation is a function, inject it with props.
                if (typeof interpolation === "function") {
                    return interpolation(props);
                }
                // Its just a normal type, allow it to pass through.
                return interpolation;
            };
            // Iterate string templates and interpolate in styled theme props.
            strings.forEach(function(string, i) {
                style += string + replaceFalsy(interpolate(interpolations[i]), "");
            });
            return style;
        };
        return styledInterpolation;
    };
    return conditionalTemplateLiteral;
};
/**
 * Creates a tagged template literal that will set styles for specific media queries.
 *
 * @remarks
 * This example would add the contained styles only if the page is below `M` breakpoint width.
 * ```tsx
 * const Foo = styled`
 *   ${styledMedia(BreakpointDown.M)`
 *     display: none;
 *   `}
 * `;
 * ```
 *
 * The following example would add the contained styles only if the page is above `XXS` and below `S` breakpoint widths.
 * ```tsx
 * const Foo = styled`
 *   ${styledMedia(BreakpointUp.XXS, BreakpointDown.S)`
 *     background: blue;
 *   `}
 * `;
 * ```
 *
 * `styledMedia` can accept any number of breakpoint parameters.
 */ export var styledMedia = function() {
    for(var _len = arguments.length, rules = new Array(_len), _key = 0; _key < _len; _key++){
        rules[_key] = arguments[_key];
    }
    /** The tagged template literal. */ var mediaTemplateLiteral = function(strings) {
        for(var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            interpolations[_key - 1] = arguments[_key];
        }
        /** The styled interpolation that will be injected with the embedded literals props. */ var styledInterpolation = function(props) {
            // Create a media tag with all passed rules joined (and).
            var style = "@media ".concat(rules.join(" and "), " {\n");
            var interpolate = function(interpolation) {
                // If the interpolation is a function, inject it with props.
                if (typeof interpolation === "function") {
                    return interpolation(props);
                }
                // Its just a normal type, allow it to pass through.
                return interpolation;
            };
            // Iterate string templates and interpolate in styled theme props.
            strings.forEach(function(string, i) {
                style += string + replaceFalsy(interpolate(interpolations[i]), "");
            });
            // Close media tag.
            style += "\n}";
            return style;
        };
        return styledInterpolation;
    };
    return mediaTemplateLiteral;
};
/** Conditional tagged template literal that only applies style for the specified theme name. */ export var styledThemeName = function(themeName) {
    return styledConditional(function(props) {
        return props.theme.name === themeName;
    });
};
/** Conditional tagged template literal that only applies style for the specified source type. */ export var styledSourceType = function(sourceType) {
    return styledConditional(function(props) {
        return props.theme.session ? props.theme.session.kernelSourceType === sourceType : false;
    });
};
/** Conditional requiring both a certain source type and theme name. */ export var styledTypeAndTheme = function(sourceType, themeName) {
    return styledConditional(function(props) {
        return props.theme.name === themeName && (props.theme.session ? props.theme.session.kernelSourceType === sourceType : false);
    });
};
// TODO(b/217320809): Refactor this to make sure we're not defining KM
// scrollbar styles in different places, as we also have a definition in
// @kaggle/material/Scrollbar.
var createKmScrollbarStyle = function(theme) {
    var backgroundColor = theme === "dark" ? darkPalette.windowBackground : "#ececed";
    return "::-webkit-scrollbar {\n    background: ".concat(backgroundColor, ";\n    height: 8px;\n    width: 8px;\n  }\n  \n  ::-webkit-scrollbar-track {\n    margin: 3px 0;\n  }\n  \n  ::-webkit-scrollbar-thumb {\n    border: none;\n    box-shadow: none;\n    background-color: ").concat(Colors.GREY_600, ";\n    border-radius: 8px;\n    min-height: 48px;\n  }");
};
export var scrollbars = {
    light: createKmScrollbarStyle("light"),
    dark: createKmScrollbarStyle("dark")
};
/** Adds styles that make the current container show an ellipsis on overflow. */ export var ellipsis = function(maxWidth) {
    return "\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  max-width: ".concat(maxWidth, ";\n");
};
